<template>
  <div class="camp-detail">
    <div class="detail-head">
      <!-- 中心信息 -->
      <div class="detail-info">
        <img class="info-cover" src="@/assets/images/researchCamp/banner.png" alt="">
        <div class="info-main">
          <div class="info-name">{{ center.name }}</div>
          <div class="info-meta">
            {{ center.provinceName }} {{ center.cityName }}<span v-if="center.directorName"> | {{ center.directorName }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="detail-panel">
      <!-- 中心简介、近期直播、中心课程、中心病例 -->
      <div class="detail-tabs">
        <div
          class="tab-item"
          :class="{ cur: active === item.key }"
          v-for="item in tabs"
          :key="item.key"
          @click="changeTab(item.key)"
        >
          {{ item.label }}
          <img src="../../assets/images/zone/img2.png" v-if="active === item.key" class="icon1" alt="">
        </div>
      </div>
      <!-- 近期直播 -->
      <div class="live-list" v-if="active === 'live'">
        <van-list v-model="listLoading" :finished="finished.live" :immediate-check="false" finished-text="没有更多了" @load="loadMoreActiveList">
          <div class="live-item" v-for="item in liveList" :key="item.id" @click="goLive(item)">
            <div class="live-cover">
              <img :src="item.cover" alt="">
              <span class="live-status" :class="item.status">
                <img v-if="item.status === 'living'" class="status-icon" src="../../assets/images/researchCamp/ic_zb.svg" alt="">
                {{ item.statusText }}
              </span>
            </div>
            <div class="live-main">
              <div class="live-title">{{ item.title }}</div>
              <div class="live-foot">
                <span class="live-time">{{ item.time }}</span>
                <button
                  class="live-book"
                  :class="{ booked: Number(item.ismake) === 1 }"
                  :disabled="item.booking"
                  type="button"
                  @click.stop="toggleBook(item)"
                >{{ Number(item.ismake) === 1 ? '已预约' : '预约' }}</button>
              </div>
            </div>
          </div>
        </van-list>
      </div>
      <!-- 中心课程 -->
      <div class="course-list" v-if="active === 'course'">
        <van-list v-model="listLoading" :finished="finished.course" :immediate-check="false" finished-text="没有更多了" @load="loadMoreActiveList">
          <div class="course-item" v-for="item in courseList" :key="item.id" @click="goCourse(item)">
            <img class="course-cover" :src="item.cover" :title="item.title" alt="">
            <div class="course-main">
              <div class="course-title">{{ item.title }}</div>
              <div class="course-desc" v-if="item.hospital">医院：{{ item.hospital }}</div>
              <div class="course-desc" v-if="item.teacher">讲师：{{ item.teacher }}</div>
            </div>
            <img class="row-arrow" src="@/assets/images/person/right.png" alt="">
          </div>
        </van-list>
      </div>
      <!-- 中心简介 -->
      <div class="intro" v-if="active === 'intro'">
        <img class="intro-banner" v-if="center.introImage" :src="center.introImage" alt="中心简介">
      </div>
      <!-- 中心病例 -->
      <div class="case-list" v-if="active === 'case'">
        <van-list v-model="listLoading" :finished="finished.case" :immediate-check="false" finished-text="没有更多了" @load="loadMoreActiveList">
          <div class="case-item" v-for="item in caseList" :key="item.id" @click="goCase(item)">
            <img class="case-cover" :src="item.cover" alt="">
            <div class="case-main">
              <div class="case-title">{{ item.title }}</div>
              <div class="case-desc" v-if="item.hospital">医院：{{ item.hospital }}</div>
              <div class="case-desc" v-if="item.author">作者：{{ item.author }}</div>
            </div>
            <img class="row-arrow" src="@/assets/images/person/right.png" alt="">
          </div>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getResearchCampDetail,
  getResearchCampLives,
  getResearchCampCourses,
  getResearchCampCases
} from '@/api/researchCamp'
import { liveMake } from '@/api/api'
import withRouteTracking from '@/utils/withRouteTracking'

const CampDetail = {
  name: 'CampDetail',
  data () {
    return {
      cover: require('@/assets/images/researchCamp/banner.png'),
      campConfigId: this.$route.query.researchCampId,
      active: 'intro',
      center: {},
      tabs: [
        { key: 'intro', label: '中心简介' },
        { key: 'live', label: '近期直播' },
        { key: 'course', label: '中心课程' },
        { key: 'case', label: '中心病例' }
      ],
      liveList: [],
      courseList: [],
      listLoading: false,
      listRequestSeq: 0,
      pageNumbers: { live: 1, course: 1, case: 1 },
      finished: { live: false, course: false, case: false },
      introList: [
        {
          title: '数字技术 智慧赋能',
          text: '通过数字化技术，实现平台内容个性化推送'
        },
        {
          title: '多维融合全面覆盖',
          text: '学术课程、海量病例、前沿文献、手术直播，多维覆盖系统化学习资源'
        },
        {
          title: '千人千面量身进阶',
          text: '实时跟进成长动态，量身定制进阶策略'
        }
      ],
      caseList: []
    }
  },
  created () {
    this.loadCamp()
    this.loadActiveList()
  },
  computed: {
    // 当前登录用户
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  methods: {
    // 加载研修营中心信息
    async loadCamp () {
      if (!this.campConfigId) return
      try {
        const response = await getResearchCampDetail(this.campConfigId)
        this.center = response.data || {}
      } catch (error) {
        this.$toast('中心信息加载失败')
      }
    },
    // 按当前页签加载直播、课程或病例
    async loadActiveList (append = false) {
      if (!this.campConfigId || this.active === 'intro') {
        return
      }
      const active = this.active
      if (append && this.listLoading) return
      if (!append) {
        this.pageNumbers[active] = 1
        this.finished[active] = false
        if (active === 'live') this.liveList = []
        if (active === 'course') this.courseList = []
        if (active === 'case') this.caseList = []
      }
      const params = { pageNum: this.pageNumbers[active], pageSize: 10 }
      const requestSeq = ++this.listRequestSeq
      this.listLoading = true
      try {
        let page
        if (active === 'live') {
          const response = await getResearchCampLives(this.campConfigId, params)
          if (requestSeq !== this.listRequestSeq) return
          page = response && response.data ? response.data : {}
          const rows = (page.list || []).map(item => this.mapLive(item))
          this.liveList = append ? this.liveList.concat(rows) : rows
        } else if (active === 'course') {
          const response = await getResearchCampCourses(this.campConfigId, params)
          if (requestSeq !== this.listRequestSeq) return
          page = response && response.data ? response.data : {}
          const rows = (page.list || []).map(item => ({
            id: item.id,
            title: item.name,
            hospital: '',
            teacher: item.lecturerNames,
            cover: item.coverUrl || this.cover
          }))
          this.courseList = append ? this.courseList.concat(rows) : rows
        } else if (active === 'case') {
          const response = await getResearchCampCases(this.campConfigId, params)
          if (requestSeq !== this.listRequestSeq) return
          page = response && response.data ? response.data : {}
          const rows = (page.list || []).map(item => ({
            id: item.baseId || item.id,
            title: item.title,
            hospital: item.hospitalName,
            author: item.keynoteSpeaker,
            cover: item.coverUrl || this.cover
          }))
          this.caseList = append ? this.caseList.concat(rows) : rows
        }
        const currentPage = Number(page && page.pageNum) || params.pageNum
        this.pageNumbers[active] = currentPage + 1
        this.finished[active] = currentPage >= Number(page && page.pages) || (page.list || []).length < 10
      } catch (error) {
        if (requestSeq !== this.listRequestSeq) return
        this.$toast('中心内容加载失败')
        this.finished[active] = true
      } finally {
        if (requestSeq === this.listRequestSeq) this.listLoading = false
      }
    },
    // 加载当前页签的下一页
    loadMoreActiveList () {
      if (!this.finished[this.active]) this.loadActiveList(true)
    },
    // 整理直播状态、时间和预约状态
    mapLive (item) {
      const start = Number(item.start)
      const end = Number(item.end)
      const now = Date.now()
      const living = item.liveState === '进行中' || (start <= now && now < end)
      return {
        id: item.liveId,
        status: living ? 'living' : 'pending',
        statusText: living ? '直播中' : '未开始',
        title: item.title,
        time: this.formatLiveTime(item.start, item.end),
        cover: item.coverUrl || item.poster || this.cover,
        ismake: Number(item.ismake || 0),
        booking: false
      }
    },
    // 直播时间按直播列表显示：07月15日 00:00 ~ 00:00
    formatLiveTime (start, end) {
      const startText = start ? this.$moment(parseInt(start)).format('MM月DD日 HH:mm') : ''
      const endText = end ? this.$moment(parseInt(end)).format('HH:mm') : ''
      if (startText && endText) return `${startText} ~ ${endText}`
      return startText || endText
    },
    // 切换详情页签
    changeTab (key) {
      this.active = key
      this.loadActiveList()
    },
    // 预约或取消预约直播
    async toggleBook (item) {
      if (item.booking) return
      const isBooked = Number(item.ismake) === 1
      item.booking = true
      try {
        const response = await liveMake({
          userId: this.userInfo.id,
          liveId: item.id,
          type: isBooked ? 0 : 1
        })
        if (response && response.code === 111) return
        item.ismake = isBooked ? 0 : 1
        this.$toast(isBooked ? '取消预约成功' : '预约成功')
      } finally {
        item.booking = false
      }
    },
    // 进入直播详情，入口与学员首页一致
    goLive (item) {
      const entrance = 181
      window.sessionStorage.setItem('entrance', entrance)
      localStorage.setItem('functionUrl', `${process.env.baseURL}${process.env.BASE_URL}/liveDetails?liveId=${item.id}&entrance=${entrance}&channel=${entrance}`)
      this.$router.push({
        path: '/liveDetails',
        query: {
          liveId: item.id,
          entrance,
          channel: entrance
        }
      })
    },
    // 进入课程详情，入口与学员首页一致
    goCourse (item) {
      const entrance = 181
      window.sessionStorage.setItem('entrance', entrance)
      localStorage.setItem('functionUrl', `${process.env.baseURL}${process.env.BASE_URL}/courserDetails?courseId=${item.id}&entrance=${entrance}&channel=${entrance}`)
      this.$router.push({
        path: '/courserDetails',
        query: {
          courseId: item.id,
          entrance,
          channel: entrance
        }
      })
    },
    // 进入病例详情，入口与学员首页一致
    goCase (item) {
      const entrance = 181
      window.sessionStorage.setItem('entrance', entrance)
      window.location.href = `${process.env.bingliUrl}/wap/index.html#/casedetails?id=${item.id}&entrance=${entrance}&businessChannel=${entrance}`
    }
  }
}

export default withRouteTracking(CampDetail)
</script>

<style lang="less" scoped>
.camp-detail {
  min-height: 100vh;
  background-color: #F9F8F7;
  background-image: url('../../assets/images/researchCamp/banner.png');
  background-repeat: no-repeat;
  background-position: center top;
  background-size: 100% auto;

  .detail-head {
    padding-top: 170px;
  }

  .detail-info {
    display: flex;
    align-items: center;
    height: 78px;
    margin: 0 13px;
    padding: 0 16px;
    border-radius: 10px;
    background: #fff;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
    box-sizing: border-box;

    .info-cover {
      width: 45px;
      height: 45px;
      border-radius: 50%;
      object-fit: cover;
      margin-right: 12px;
      flex-shrink: 0;
    }

    .info-main {
      flex: 1;
      min-width: 0;

      .info-name {
        font-size: 14px;
        font-weight: 400;
        color: #000;
        line-height: 20px;
      }

      .info-meta {
        margin-top: 0;
        min-width: 0;
        overflow: hidden;
        font-size: 12px;
        font-weight: 400;
        color: #81766F;
        line-height: 20px;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }

  .detail-panel {
    margin: 13px 13px 16px;
    padding: 4px 14px 0 16px;
    border-radius: 10px;
    background: #fff;
    box-sizing: border-box;

    .detail-tabs {
      display: flex;
      height: 48px;
      background: #FFF;

      .tab-item {
        flex: 1;
        position: relative;
        line-height: 48px;
        text-align: center;
        font-size: 14px;
        font-weight: 400;
        color: #564C47;

        .icon1 {
          width: 24px;
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          bottom: 6px;
        }

        &.cur {
          color: #EB1700;
          font-weight: 500;
        }
      }
    }

    .live-item,
    .course-item,
    .case-item {
      display: flex;
      align-items: flex-start;
      padding: 12px 0;
      border-bottom: 1px solid #F3F3F3;
    }

    .live-item:last-child {
      border-bottom: none;
      padding-bottom: 0;
    }
    .course-item:last-child {
      border-bottom: none;
      padding-bottom: 0;
    }
    .case-item:last-child {
      border-bottom: none;
      padding-bottom: 0;
    }

    .row-arrow {
      width: 12px;
      height: 12px;
      margin-left: 8px;
      margin-top: auto;
      margin-bottom: auto;
      flex-shrink: 0;
    }

    .live-main,
    .course-main,
    .case-main {
      flex: 1;
      min-width: 0;
    }

    .live-title,
    .course-title,
    .case-title {
      font-size: 12px;
      font-weight: 500;
      color: #000;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }

    .live-foot {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 6px;

      .live-time {
        margin-top: 0;
      }
    }

    .live-book {
      height: 22px;
      padding: 0 14px;
      border: 1px solid #eb1700;
      border-radius: 11px;
      background: #eb1700;
      color: #fff;
      font-size: 11px;
      font-weight: 400;
      line-height: 20px;
      flex-shrink: 0;

      &.booked {
        background: #fff;
        color: #eb1700;
      }
    }

    .live-time,
    .course-desc,
    .case-desc {
      margin-top: 4px;
      font-size: 11px;
      color: #81766F;
    }

    .live-cover {
      position: relative;
      width: 100px;
      height: 59px;
      margin-right: 10px;
      border-radius: 4px;
      overflow: hidden;
      flex-shrink: 0;
      background: #F3F3F3;

      > img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }

      .live-status {
        position: absolute;
        left: 0;
        top: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 18px;
        width: 50px;
        border-radius: 4px 0 4px 0;
        font-size: 10px;
        color: #fff;
        background: #564C47;
        box-sizing: border-box;

        .status-icon {
          width: 8px;
          height: 8px;
          margin-right: 2px;
          flex-shrink: 0;
        }

        &.living {
          background: #EB1700;
        }
      }
    }

    .course-cover,
    .case-cover {
      width: 100px;
      height: 58px;
      margin-right: 10px;
      border-radius: 5px;
      object-fit: cover;
      flex-shrink: 0;
    }
  }

  .intro-banner {
    width: 100%;
    height: auto;
    object-fit: contain;
    padding-bottom: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/researchCamp/detail.vue